import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { RuleListQuery } from '@rossum/api-client/rules';
import { useApiClient } from '../../../lib/apiClient';
import { RULES_QUERY_KEY } from './rulesQueryKeys';

export const useListRules = (
  query: RuleListQuery,
  options?: { enabled?: boolean }
) => {
  const api = useApiClient();
  return useQuery({
    queryKey: [RULES_QUERY_KEY, 'list', query],
    queryFn: () => api.unpaginatedRequest(endpoints.rules.list)(query),
    enabled: options?.enabled ?? true,
  });
};
